import { Routes } from '@angular/router';
import { DataRequiredGuard } from './core/guards/data-required.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: 'contact-details',
    loadComponent: () => import('./features/contact-details/contact-details.component').then(m => m.ContactDetailsComponent),
    canActivate: [DataRequiredGuard]
  },
  {
    path: 'meter-confirmation',
    loadComponent: () => import('./features/meter-confirmation/meter-confirmation.component').then(m => m.MeterConfirmationComponent),
    canActivate: [DataRequiredGuard]
  },
  {
    path: 'meter-review',
    loadComponent: () => import('./features/meter-review/meter-review.component').then(m => m.MeterReviewComponent),
    canActivate: [DataRequiredGuard]
  },
  {
    path: 'quotes/:data',
    loadComponent: () => import('./features/generate-quote/generate-quote.component').then(m => m.GenerateQuoteComponent),
  },
  {
    path: 'quotes',
    loadComponent: () => import('./features/generate-quote/generate-quote.component').then(m => m.GenerateQuoteComponent),
    canActivate: [DataRequiredGuard]
  },
  {
    path: 'business-details',
    loadComponent: () => import('./features/business-details/business-details.component').then(m => m.BusinessDetailsComponent),
    canActivate: [DataRequiredGuard]
  },
  {
    path: 'credit-check',
    loadComponent: () => import('./core/components/credit-check-failure/credit-check-failure.component').then(m => m.CreditCheckFailureComponent),
  },
  {
    path: 'application-review',
    loadComponent: () => import('./features/application-summary/application-summary.component').then(m => m.ApplicationSummaryComponent),
    canActivate: [DataRequiredGuard]
  },
  {
    path: 'switch-confirmation',
    loadComponent: () => import('./features/switch-confirmation/switch-confirmation.component').then(m => m.SwitchConfirmationComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'cookies',
    loadComponent: () => import('./features/cookies-policy/cookies-policy.component').then(m => m.CookiesPolicyComponent)
  },
  {
    path: 'cookies/how-we-use-cookies',
    loadComponent: () => import('./features/how-we-use-cookie/how-we-use-cookie.component').then(m => m.HowWeUseCookieComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./core/components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  }
];
